import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ToastContainer, toast } from "react-toastify";
import "sweetalert2/src/sweetalert2.scss";
import Lightbox from "react-image-lightbox";
import moment from "moment";
import ReactTooltip from 'react-tooltip';

//import filter modal
import FilterModal from "../../../components/Modal/FilterModal";
// ../.././components/Common/Utils.js"
import {
    getRequest,
    postRequest,
    deleteRequest,
    putRequestForm,
    putRequest,
    postRequestForm,
    deleteConfirmationWords,
} from "../../../components/Common/Utils";

import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import axios from "axios";

import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Spinner,
    Badge,
    UncontrolledTooltip,
    Modal,
    Button,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { change } from "redux-form";
import { id } from "date-fns/locale";
import HomeBlockDragModal from "../DragDropModalHomeBlock/HomeBlockDragModal";

const filterObj = {
    first_name: "",
    last_name: "",
    gender: "",
    email: "",
    phone: "",
    country: "",
    nationality: "",
    bookingCode: "",
    bookingDate: "",
    agentEmail: "",
};

const SearchHomeBlockList = (props) => {
    console.log("props", props);
    const [modal_center, setmodal_center] = useState(false);
    const [HomeBlockdata, setHomeBlockdata] = useState([]);
    const [HomeOrderBlockdata, setHomeOrderBlockdata] = useState([]);
    const [loader, setLoader] = useState(false);
    const [searchText, setSearchText] = useState("");

    const [value, setValue] = React.useState(10);

    const [sort, setsort] = React.useState("order");
    const [sortOrder, setsortOrder] = React.useState("asc");

    const [currentFPage, setCurrentFPage] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [sizePerPageOrg, setSizePerPage] = useState(10);
    const [image, setImage] = React.useState("");
    const [openLightbox, setOpenLightBox] = React.useState(false);
    const [model, setModel] = useState(false);
    const [filter, setFilter] = useState({ ...filterObj });
    const [showOrder, setShowOrder] = useState(false);

    useEffect(() => {
        HomeBlockManagment();
    }, [currentPage]);

    useEffect(() => {
        HomeBlockManagment();
    }, [sort, sortOrder]);


    const closeModal = () => {
        setModel(false);
    };

    const toggleModel = () => {
        console.log("toggleModel", model);
        setModel(!model);
    };

    const handleTableChange = (type, { page, sizePerPage, searchText }) => {
        if (type === "pagination") {
            if (page != currentPage) {
                setCurrentPage(page);
                console.log("page", page);
            }
        }

        console.log("type", type);

        if (type === "search") {
            console.log("searchText", searchText);
        }
    };

    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    const updateFilter = (key, value) => {
        const filterObj = { ...filter };
        filterObj[key] = value;
        setFilter(filterObj);
    };

    const applyFilter = () => {
        const filterArgs = [];

        Object.keys(filter).forEach((key) => {
            if (
                filter[key] !== "" &&
                filter[key] !== null &&
                filter[key] !== undefined
            ) {
                var filterObject = {
                    [key]: filter[key],
                };

                if (key === "title") {
                    filterObject.type = "regex";
                } else if (key === "homeBlockType") {
                    filterObject.type = "eq";
                } else if (key === "sizeId") {
                    filterObject.type = "obj-eq";
                } else if (key === "createdAt") {
                    filterObject.type = "date-eq";
                }

                filterArgs.push(filterObject);
            }
        });

        console.log("filterArgs", filterArgs);
        toggleModel();
        HomeBlockManagment(filterArgs);
    };

    const getFilters = () => {
        const filterArgs = [];

        Object.keys(filter).forEach((key) => {
            if (
                filter[key] !== "" &&
                filter[key] !== null &&
                filter[key] !== undefined
            ) {
                var filterObject = {
                    [key]: filter[key],
                };

                if (key === "title") {
                    filterObject.type = "regex";
                } else if (key === "homeBlockType") {
                    filterObject.type = "eq";
                } else if (key === "sizeId") {
                    filterObject.type = "obj-eq";
                } else if (key === "createdAt") {
                    filterObject.type = "date-eq";
                }

                filterArgs.push(filterObject);
            }
        });
        return filterArgs;
    };

    const GetValueOnChange = async (isActive, item) => {
        const payload = {
            searchBlockId: item?._id,
            enable: isActive == true ? false : true,
        }
        const res = await postRequest("home-block/search/update", payload);
        if (res.status) {
            toast.success(res.message);
            HomeBlockManagment();
        } else {
            toast.error("Something went wrong");
            setLoader(false);
        }
    };

    const resetFilter = () => {
        setFilter({ ...filterObj });
        toggleModel();
        HomeBlockManagment();
    };

    function createdAtdata(cellContent, row) {
        return (
            <React.Fragment>
                <div>
                    <p>{moment(row.createdAt).format("DD-MM-YYYY")} </p>
                </div>
            </React.Fragment>
        );
    }

    function activeFormatter(cellContent, row) {
        return (
            <>
                <button
                    className={`btn ${row?.enable ? 'btn-active' : 'btn-deactive'}`}
                    type="button"
                    onClick={() => GetValueOnChange(row?.enable, row)}
                >
                    {row?.enable ? 'Published' : 'UnPublished'}
                </button>
            </>
        );
    }

    function HomeBlockFormatter(cellContent, row) {
        return (
            <>
                <img
                    src={row.image}
                    onClick={() => showLightBox(row.image)}
                    alt="Not found HomeBlock"
                    width={"50px"}
                />
            </>
        );
    }

    function ImgCoverFormatter(cellContent, row) {
        return (
            <>
                <img
                    src={row.cover}
                    // onClick={() => showLightBox(row.cover)}
                    alt="cover img"
                    width={"50px"}
                />
            </>
        );
    }
    const showLightBox = (image) => {
        setImage(image);
        setOpenLightBox(true);
    };

    const handleDownload = () => {
        const downloadLink = document.createElement("a");
        downloadLink.href = image;
        downloadLink.download = "downloaded-image.jpg";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    function SNoFormatter(cellContent, row, i) {
        return <>{i + 1}</>;
    }

    const components = [
        <div className="row mb-4" key="title">
            <label className="col-sm-3 col-form-label">First Name</label>
            <div className="col-sm-6">
                <input
                    type="text"
                    value={filter.first_name}
                    onChange={(e) => updateFilter("first_name", e.target.value)}
                    name="first_name"
                    className="form-control"
                />
            </div>
        </div>,
        <div className="row mb-4" key="title">
            <label className="col-sm-3 col-form-label">Last Name</label>
            <div className="col-sm-6">
                <input
                    type="text"
                    value={filter.last_name}
                    onChange={(e) => updateFilter("last_name", e.target.value)}
                    name="last_name"
                    className="form-control"
                />
            </div>
        </div>,

        <div className="row mb-4" key="title">
            <label className="col-sm-3 col-form-label">Email</label>
            <div className="col-sm-6">
                <input
                    type="text"
                    value={filter.email}
                    onChange={(e) => updateFilter("email", e.target.value)}
                    name="email"
                    className="form-control"
                />
            </div>
        </div>,
        <div className="row mb-4" key="title">
            <label className="col-sm-3 col-form-label">Phone</label>
            <div className="col-sm-6">
                <input
                    type="text"
                    value={filter.phone}
                    onChange={(e) => updateFilter("phone", e.target.value)}
                    name="phone"
                    className="form-control"
                />
            </div>
        </div>,
        //
        <div className="row mb-4" key="title">
            <label className="col-sm-3 col-form-label">Agency</label>
            <div className="col-sm-6">
                <input
                    type="text"
                    value={filter.agentEmail}
                    onChange={(e) => updateFilter("agentEmail", e.target.value)}
                    name="agentEmail"
                    className="form-control"
                />
            </div>
        </div>,

        <div className="row mb-4" key="title">
            <label className="col-sm-3 col-form-label">Booking Date</label>
            <div className="col-sm-6">
                <input
                    type="text"
                    value={filter.bookingDate}
                    onChange={(e) => updateFilter("bookingDate", e.target.value)}
                    name="bookingDate"
                    className="form-control"
                />
            </div>
        </div>,
        //
        <div className="row mb-4" key="title">
            <label className="col-sm-3 col-form-label">Country</label>
            <div className="col-sm-6">
                <input
                    type="text"
                    value={filter.country}
                    onChange={(e) => updateFilter("country", e.target.value)}
                    name="country"
                    className="form-control"
                />
            </div>
        </div>,
        <div className="row mb-4" key="title">
            <label className="col-sm-3 col-form-label">Booking Code</label>
            <div className="col-sm-6">
                <input
                    type="text"
                    value={filter.bookingCode}
                    onChange={(e) => updateFilter("bookingCode", e.target.value)}
                    name="bookingCode"
                    className="form-control"
                />
            </div>
        </div>,
        <div className="row mb-4" key="title">
            <label className="col-sm-3 col-form-label">Nationality</label>
            <div className="col-sm-6">
                <input
                    type="text"
                    value={filter.nationality}
                    onChange={(e) => updateFilter("nationality", e.target.value)}
                    name="nationality"
                    className="form-control"
                />
            </div>
        </div>,

        <div className="mt-5 mt-lg-4" key="submit">
            <div className="row justify-content-end">
                <div className="col-sm-9">
                    <div>
                        <button
                            type="button"
                            onClick={applyFilter}
                            className="btn btn-primary w-md"
                        >
                            Filter
                        </button>
                        <button
                            onClick={resetFilter}
                            type="button"
                            className="btn btn-danger w-md mx-4"
                        >
                            Reset
                        </button>
                    </div>
                </div>
            </div>
        </div>,
    ];

    const columns = [
        {
            text: "S.NO",
            formatter: SNoFormatter,
            sort: false,
        },

        {
            dataField: "title",
            text: "Title Name",
            sort: false,
        },
        {
            dataField: "showTitle",
            text: "Show Title",
            sort: false,
        },
        {
            dataField: "description",
            text: "description",
            sort: false,
        },
        {
            dataField: "type",
            text: "Type",
            sort: false,
        },
        {
            formatter: activeFormatter,
            text: "Status",
            sort: false,
        },
        {
            dataField: "actions",
            text: "Actions",
            formatter: iconFormatter,
            sort: false,
        },
    ];
    const handleChange = (event) => {
        setSizePerPage(event.target.value);
        if (currentPage != 1) {
            setCurrentPage(1);
        } else {
            HomeBlockManagment(null, event.target.value);
        }
    };
    const handlesorting = (event) => {
        setsort(event.target.value);
    };
    const handlesortOrder = (event) => {
        setsortOrder(event.target.value);
    };
    const handleReload = () => {
        setSearchText("");
        HomeBlockManagmentlist();
    };

    function iconFormatter(cellContent, row) {
        return (
            <div className="d-flex gap-2">
                <button type="button" className=" btn btn-primary">
                    <Link
                        to={{
                            pathname: `/update-search-block`,
                            state: { row },
                        }}
                    >
                        <i className="fal fa-edit fs-5 text-light"></i>
                    </Link>
                </button>

                <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => handlerdelete(row._id)}
                >
                    <i className="fal fa-trash  fs-5"></i>
                </button>
            </div>
        );
    }

    const limit = 10;

    const exportCSV = async () => {
        setLoader(true);

        const filterArgs = getFilters();
        const payload = {
            sortField: sort,
            sortOrder: sortOrder,
        };

        if (filterArgs?.length) {
            payload.filterArgs = filterArgs;
        } else {
            if (searchText) {
                payload.search = searchText;
            }
        }

        try {
            const response = await postRequest(`HomeBlock/export-csv`, payload);
            const data = response.data;
            window.location.href = data.url;
            console.log("data", data);
        } catch (error) {
            console.log("Failed to fetch data:", error);
        } finally {
            setLoader(false);
        }
    };

    const HomeBlockManagment = async (filterArgs = [], limit = null) => {
        console.log(currentPage);
        setLoader(true);
        const payload = {
            limit: limit ? limit : sizePerPageOrg,
            page: currentPage,
            sortField: sort,
            sortOrder: sortOrder,
        };

        if (filterArgs?.length) {
            payload.filterArgs = filterArgs;
        } else {
            if (searchText) {
                payload.search = searchText;
            }
        }
        try {
            const response = await postRequest(`home-block/search/list`, payload);
            const data = response.data;

            setTotalPage(data.count);
            setCurrentFPage(data.page);
            setHomeBlockdata(data.list);
        } catch (error) {
            console.log("Failed to fetch data:", error);
        } finally {
            setLoader(false);
        }
    };

    const HomeBlockManagmentlist = async (filterArgs = [], limit = null) => {
        console.log(currentPage);
        setLoader(true);
        const payload = {
            limit: limit ? limit : sizePerPageOrg,
            page: currentPage,
            sortField: sort,
            sortOrder: sortOrder,
        };

        try {
            const response = await postRequest(`home-block/search/list`, payload);
            const data = response.data;

            setTotalPage(data.count);
            setCurrentFPage(data.page);
            setHomeBlockdata(data.list);
        } catch (error) {
            console.log("Failed to fetch data:", error);
        } finally {
            setLoader(false);
        }
    };

    const handlerdelete = (id, ids) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to delete this Home Block",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                showRandomWordDialog(id, ids);
            }
        });
    };

    const showRandomWordDialog = (id, ids) => {
        const randomIndex = Math.floor(
            Math.random() * deleteConfirmationWords.length
        );
        const randomWord = deleteConfirmationWords[randomIndex];

        Swal.fire({
            title: "Confirmation Required",
            text: `To confirm deletion, please enter the word: ${randomWord}`,
            icon: "warning",
            input: "text",
            inputPlaceholder: `Type '${randomWord}' to confirm`,
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Confirm",
        }).then((result) => {
            if (result.isConfirmed && result.value === randomWord) {
                deleteRequestFunction(id, ids);
            } else if (result.isConfirmed) {
                Swal.fire(
                    "Incorrect Entry",
                    "Please enter the correct word to confirm.",
                    "error"
                );
            }
        });
    };

    const deleteRequestFunction = async (id, ids) => {
        const response = await postRequest("home-block/search/remove", {
            homeBlockId: id,
            isDeleted: true,
        });
        if (response.status) {
            Swal.fire("Deleted!", "Deleted successfully");
            HomeBlockManagmentlist();
        } else {
            Swal.fire("Error!", "Something went wrong");
        }
    };




    // home block order 


    const updateHomeblockDataDragDrop = async (data) => {
        console.log({ data })
        setLoader(true);
        const response = await postRequest(`home-block/search/update/order`, {
            data
        });

        if (response.status) {
            toast.success("Order updated successfully");
            setShowOrder(false)
            // wait 3 seconds before reloading the page
            setTimeout(() => {
                HomeBlockManagmentlist()
            }, 1000);

        } else {
            toast.error("Something went wrong");
        }

    };


      const handleShowOrder = async () => {
        const payload = {
          limit: totalPage,
          sortField: 'order',
          sortOrder: 'asc',
        };
        // setLoader(true);
        try {
          const response = await postRequest(`home-block/search/list`, payload);
          const data = response.data?.list.filter((item) => item?.enable === true);
          setHomeOrderBlockdata(data);
          setShowOrder(true);
        } catch (error) {
          console.log("Failed to fetch data:", error);
        } finally {
          setLoader(false);
        }
      }
    



    return (
        <>
            <React.Fragment>
                <ToastContainer />
                <Row>
                    <div className="col-md-6">
                        <div className="page-title-box">
                            <h4>Home Block Management</h4>

                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item active">Home Block Management</li>
                                : <li className="breadcrumb-item w-34">Search Block List <i
                                    data-tip
                                    data-for="1-title-tooltip"
                                    className="fa fa-info-circle"
                                    style={{ marginLeft: '5px', cursor: 'pointer' }}
                                ></i>

                                    <ReactTooltip id="1-title-tooltip" place="bottom">
                                    Search Block: In a mobile app, the "search block" is a dedicated area where users can enter 
                                    search queries to quickly find products, content, 
                                    or information. It facilitates easy and efficient browsing and navigation within the app.
                                    </ReactTooltip></li>
                            </ol>
                        </div>
                    </div>
                    <div className="col-md-6 text-end">

                        <Button
                            onClick={() => handleShowOrder()}
                            className="btn btn-info"
                            style={{ marginRight: "10px" }}
                        >
                            <i className="fas fa-grip-vertical"></i> Order
                        </Button>
                        <Link to="/create-search-block">
                            {" "}
                            <Button>
                                {" "}
                                <i class="fas fa-plus"></i> Create
                            </Button>{" "}
                        </Link>

                        &nbsp;&nbsp;&nbsp;
                    </div>
                    <Col className="col-12">
                        <Card>
                            {loader ? (
                                <CardBody style={{ height: "100px" }}>
                                    <Spinner
                                        color="info"
                                        style={{
                                            height: "4rem",
                                            width: "4rem",
                                            position: "absolute",
                                            left: "50%",
                                        }}
                                    >
                                        Loading...
                                    </Spinner>
                                </CardBody>
                            ) : (
                                <CardBody className="table-shorting">
                                    {
                                        <PaginationProvider
                                            pagination={paginationFactory({
                                                page: currentFPage,
                                                sizePerPage: sizePerPageOrg,
                                                totalSize: totalPage,
                                                custom: true,
                                            })}
                                        >
                                            {({ paginationProps, paginationTableProps }) => (
                                                <>
                                                    <ToolkitProvider
                                                        keyField="_id"
                                                        data={HomeBlockdata}
                                                        columns={columns}
                                                    >
                                                        {(props) => (
                                                            <Row>
                                                                <Col className="col-lg-12 d-flex mb-3">
                                                                    <label className="mb-0 text-label">
                                                                        Page Size
                                                                    </label>

                                                                    <select
                                                                        value={sizePerPageOrg}
                                                                        onChange={handleChange}
                                                                        className="form-select"
                                                                        style={{ width: "7%" }}
                                                                    >
                                                                        <option value="10">10</option>

                                                                        <option value="20">20</option>

                                                                        <option value="50">50</option>
                                                                    </select>

                                                                    <label className="mb-0 text-label ms-3">
                                                                        Sort By:
                                                                    </label>
                                                                    <select
                                                                        value={sort}
                                                                        onChange={handlesorting}
                                                                        className="form-select"
                                                                        style={{ width: "10%" }}
                                                                    >
                                                                         <option value="order">Order</option>
                                                                        <option value="title">Title Name</option>
                                                                        <option value="showTitle">
                                                                            Show Title
                                                                        </option>

                                                                        <option value="type">Type</option>
                                                                        <option value="description">
                                                                            Description
                                                                        </option>
                                                                    </select>
                                                                    <label className="mb-0 text-label ms-3">
                                                                        Sort Order:
                                                                    </label>
                                                                    <select
                                                                        value={sortOrder}
                                                                        onChange={handlesortOrder}
                                                                        className="form-select"
                                                                        style={{ width: "10%" }}
                                                                    >
                                                                        <option value="asc"> Ascending</option>
                                                                        <option value="desc">Descending</option>
                                                                    </select>
                                                                    <div className="filter-item">
                                                                        <input
                                                                            type="search"
                                                                            placeholder="Search"
                                                                            value={searchText}
                                                                            class="form-control"
                                                                            onChange={(e) =>
                                                                                setSearchText(e.target.value)
                                                                            }
                                                                            style={{ width: "30%" }}
                                                                        />
                                                                        <button
                                                                            onClick={() => {
                                                                                HomeBlockManagment();
                                                                            }}
                                                                            type="button"
                                                                            className="btn btn-primary mx-2"
                                                                        >
                                                                            Search
                                                                        </button>

                                                                        <button
                                                                            type="button"
                                                                            onClick={handleReload}
                                                                            className="btn btn-danger mx-2"
                                                                        >
                                                                            Reset
                                                                        </button>
                                                                        {/* <button
                                      type="button"
                                      onClick={toggleModel}
                                      className="btn btn-info"
                                    >
                                      Filter
                                    </button> */}
                                                                    </div>
                                                                </Col>

                                                                <Col className="col-lg-12 text-end">
                                                                    <BootstrapTable
                                                                        onTableChange={handleTableChange}
                                                                        remote={true}
                                                                        classes="table-striped"
                                                                        {...props.baseProps}
                                                                        {...paginationTableProps}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        )}
                                                    </ToolkitProvider>

                                                    <Row>
                                                        <Col className="col-lg-12 text-end">
                                                            <div className="text-md-right">
                                                                <PaginationListStandalone
                                                                    {...paginationProps}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </>
                                            )}
                                        </PaginationProvider>
                                    }
                                </CardBody>
                            )}
                        </Card>
                    </Col>
                </Row>
                {openLightbox && (
                    <>
                        <Lightbox
                            mainSrc={image}
                            onCloseRequest={() => setOpenLightBox(false)}
                            toolbarButtons={[
                                <button
                                    className="btn btn-primary"
                                    key="download"
                                    onClick={handleDownload}
                                >
                                    Download
                                </button>,
                            ]}
                        />
                    </>
                )}
            </React.Fragment>
            <FilterModal
                show={model}
                closeModal={closeModal}
                components={components}
            />



            {/* <HomeBlockDragModal
          show={showOrder}
          closeModal={() => setShowOrder(false)}
          data={HomeBlockdata}
          // setData={updateHomeblockData}
        /> */}



            <HomeBlockDragModal
                show={showOrder}
                closeModal={() => setShowOrder(false)}
                data={HomeOrderBlockdata}
                setData={updateHomeblockDataDragDrop}
                title={"HomeBlock List Ordering"}

            />

        </>
    );
};

export default SearchHomeBlockList;
